"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ticket = void 0;
const react_1 = __importDefault(require("react"));
const Ticket = ({ size, color }) => {
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 52 52", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M17.967 9.286v31.648M2.143 33.723a1.756 1.756 0 0 1 1.406-1.72 7.035 7.035 0 0 0 0-13.785 1.755 1.755 0 0 1-1.406-1.721v-5.453a1.758 1.758 0 0 1 1.758-1.758H46.1a1.758 1.758 0 0 1 1.758 1.758v5.453a1.756 1.756 0 0 1-1.406 1.72 7.035 7.035 0 0 0 0 13.785 1.755 1.755 0 0 1 1.406 1.721v5.453a1.758 1.758 0 0 1-1.758 1.758H3.901a1.758 1.758 0 0 1-1.758-1.758v-5.453Z", stroke: color || '#25CFBB', strokeWidth: "3.516", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.Ticket = Ticket;
